
export function sanitizeTextForWinAnsiPdf(text: string): string {
  const replaced = text
    .replace(/\u2011/g, "-")
    .replace(/\u2010/g, "-")
    .replace(/\u00AD/g, "")
    .replace(/\uFEFF/g, "")
    .replace(/\u2013/g, "-")
    .replace(/\u2014/g, "--")
    .replace(/\u2212/g, "-")
    .replace(/\u00A0/g, " ")
    .replace(/[\u2018\u2019\u2032]/g, "'")
    .replace(/[\u201C\u201D\u2033]/g, '"')
    .replace(/\u2026/g, "...")
    .replace(/\u2022/g, "*");

  let out = "";
  for (const ch of replaced) {
    const c = ch.codePointAt(0)!;
    if (c === 9 || c === 10 || c === 13) {
      out += ch;
      continue;
    }
    if (c >= 0x20 && c <= 0x7e) {
      out += ch;
      continue;
    }
    if (c >= 0xa0 && c <= 0xff) {
      out += ch;
      continue;
    }
    out += "?";
  }
  return out;
}
